/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductUpdateDto } from '../models/ProductUpdateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class ProductUpdateService {

    /**
     * Get all site employee product updates
     * @param siteEmployeeId
     * @returns ProductUpdateDto
     * @throws ApiError
     */
    public static productUpdateControllerGet(
        siteEmployeeId: string,
    ): CancelablePromise<Array<ProductUpdateDto>> {
        return __request({
            method: 'GET',
            path: `/product-update/${siteEmployeeId}`,
        });
    }

    /**
     * Set product update to read
     * @param id
     * @returns ProductUpdateDto
     * @throws ApiError
     */
    public static productUpdateControllerSetRead(
        id: string,
    ): CancelablePromise<ProductUpdateDto> {
        return __request({
            method: 'PATCH',
            path: `/product-update/set-read/${id}`,
        });
    }

    /**
     * Sync data with Lokalise
     * @returns string
     * @throws ApiError
     */
    public static productUpdateControllerSync(): CancelablePromise<string> {
        return __request({
            method: 'POST',
            path: `/product-update/sync`,
        });
    }

}